import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import ContactUs from "../components/ContactUs/ContactUs";
// import { useAuth } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";

function ContactPage() {
  // const { user } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="page-container">
      <div className="content-wrap">
        <ContactUs />
      </div>
    </div>
  );
}

export default ContactPage;
